import "@intern/oidc-client"
import {AuthContext, createAuthContext, User} from "@intern/oidc-client";

let currentUser: User | null = null;

const baseAuthContext = createAuthContext({
  authorityUrl: process.env.VUE_APP_AUTH as string,
  clientId: "salesman",
  requireLogin: true,
  onUserLoaded(user: User) {
    currentUser = user;
  },
  onUserUnloaded() {
    currentUser = null;
  },
});

export const authContext = {
  ...baseAuthContext,
  authenticated() {
    return currentUser != null;
  },
  get user() {
    return currentUser;
  }
} as ExtendedAuthContext;

interface ExtendedAuthContext extends AuthContext {
  authenticated: () => boolean;
  user: User | null;
}
